/**
 * ## Reservation Limit component
 *
 * @module src/components/reslimit
 */

"use strict";

const conf = require("../../config");
const ressplit = require("../ressplit");
const moment = require("moment-timezone");
const l = require("../../common").localization;

let y = 0;
let time24 = "h:mm a";
const current = {};

/** Res Limit
 */
const create = (targetDiv, data, location, callback) => {
  current.targetDiv = targetDiv;
  current.data = data;
  current.location = location;
  current.callback = callback;
  $(`#${targetDiv}`).html("");
  time24 = l.translate("h:mm a");
  if (location.hasOwnProperty("time24") && location.time24) {
    time24 = "H:mm";
  }
  let thisHTML = '<div id="reslimit_shell">';
  thisHTML += '<div id="reslimit_block">';
  thisHTML += '    <div class="reslimit_arrow2"></div>';
  thisHTML += '    <div id="reslimit_detail"></div>';
  thisHTML += "</div>";
  // set by date or by day, show and populate controls with defaults or live data.
  thisHTML += "";
  thisHTML +=
    '<div id="reslimit_add_start" class="btn1"><i class="fa fa-plus fa-2x"></i></div>';
  thisHTML += '<div id="reslimit_remove_start" class="btn1">';
  thisHTML += '<i class="fa fa-times fa-2x"></i></div>';
  thisHTML +=
    '<div class="reslimit_note"><i class="fas fa-arrow-down fa-2x"></i>';
  thisHTML += '<div class="reslimit_note_adjust">';
  thisHTML += "Select a box to edit the properties of that time window";
  thisHTML += "</div>";
  thisHTML += "</div>";
  thisHTML += '<div class="clear"></div>';
  thisHTML += '<div class="reslimit_hold">';
  thisHTML += '    <div id="reslimit_times"></div>';
  thisHTML += '    <div id="reslimit_set">';
  for (let i = 0; i < data.limits.length; ++i) {
    if (i === 0) {
      thisHTML += `<div class="reslimit_drag" id="reslimit_drag_${i}" data-index="0">\
                            <i class="fa fa-times"></i></div>`;
    } else {
      thisHTML += `<div class="reslimit_drag" id="reslimit_drag_${i}" data-index="0">\
                            <i class="fa fa-bars"></i></div>`;
    }
    thisHTML += `<div class="reslimit_slide" id="reslimit_slide_${i}">`;
    thisHTML += '<div class="reslimit_arrow"></div>';
    thisHTML += `<div class="reslimit_time" id="reslimit_time_${i}" \
                        data-index="${i}">time</div>`;
    thisHTML += `<div class="reslimit_preview" id="reslimit_preview_${i}" data-index="${i}">`;
    thisHTML +=
      '<div class="reslimit_preview_box reslimit_preview_box1">&nbsp</div>';
    thisHTML +=
      '<div class="reslimit_preview_box reslimit_preview_box2">&nbsp</div>';
    thisHTML +=
      '<div class="reslimit_preview_box reslimit_preview_box3">&nbsp</div>';
    thisHTML +=
      '<div class="reslimit_preview_box reslimit_preview_box4">&nbsp</div>';
    thisHTML += "</div>";
    thisHTML += "</div>";
    thisHTML += `<div class="reslimit_body" id="reslimit_body_${i}">`;
    thisHTML += "</div>";
    thisHTML += '<div class="clear"></div>';
  }
  thisHTML += `<div class="reslimit_drag" id="reslimit_drag_${data.limits.length}">\
                    <i class="fa fa-times"></i></div>`;
  thisHTML += "</div>";
  thisHTML += "</div>";
  thisHTML += '<div class="clear"></div>';
  thisHTML +=
    '<div id="reslimit_add_end" class="btn1"><i class="fa fa-plus fa-2x"></i></div>';
  thisHTML +=
    '<div id="reslimit_remove_end" class="btn1"><i class="fa fa-times fa-2x"></i>';
  thisHTML += "</div>";
  thisHTML += `<div id="reslimit_save" class="btn1">\
                    ${l.translate("Save Changes To This Set")}</div>`;
  thisHTML += '<div class="clear"></div>';
  thisHTML += "</div>";
  $(`#${targetDiv}`).html(thisHTML);

  for (let i = 0; i < data.limits.length; ++i) {
    $(`#reslimit_body_${i}`).height(data.limits[i].size);
    $(`#reslimit_slide_${i}`).css(
      "top",
      $(`#reslimit_body_${i}`).height() / 2 -
        20 +
        $(`#reslimit_body_${i}`).position().top
    );
  }

  // set time labels

  const totalTimes = (data.close - data.open) * 2;
  let labels = "";
  let c = 0;
  for (let i = data.open; i <= data.close; ++i) {
    ++c;
    if ((i / 4) % 1 === 0) {
      labels += `<div class="reslimit_label">${moment(
        conf.vars.time[i],
        "H:mma"
      ).format(time24)}</div>`;
    } else if ((i / 2) % 1 === 0) {
      if (data.close - data.open < 52) {
        labels += `<div class="reslimit_label_alt">${moment(
          conf.vars.time[i],
          "H:mma"
        ).format(time24)}</div>`;
      } else {
        labels += '<div class="reslimit_label_alt">...</div>';
      }
    } else {
      labels += '<div class="reslimit_label"></div>';
    }
  }

  $("#reslimit_times").html(labels);

  // minor pixel adjustment for alignment purposes
  const increment = $("#reslimit_set").outerHeight() / c + 0;

  $(".reslimit_label").height(increment);
  $(".reslimit_label_alt").height(increment);

  for (let i = 0; i < data.limits.length; ++i) {
    setTimes(data, i, increment);
  }

  $(`#${targetDiv}`).off("touchmove mousemove");
  $(`#${targetDiv}`).on("touchmove mousemove", (e) => {
    e.preventDefault();
    movethis(e.pageY);
  });

  const movethis = (pageY, reset) => {
    let move = 0;
    if (!reset) {
      move = pageY - y;
    }
    for (let i = 0; i < data.limits.length - 1; ++i) {
      if (data.limits[i + 1].active) {
        if (
          (move <= 0 && $(`#reslimit_body_${i}`).height() > 0) ||
          (move > 0 && $(`#reslimit_body_${i + 1}`).height() > 0)
        ) {
          $(`#reslimit_body_${i}`).css("height", move + data.limits[i].size);
          $(`#reslimit_body_${i + 1}`).css(
            "height",
            -move + data.limits[i + 1].size
          );
          $(`#reslimit_slide_${i}`).css(
            "top",
            $(`#reslimit_body_${i}`).height() / 2 -
              20 +
              $(`#reslimit_body_${i}`).position().top
          );
          $(`#reslimit_slide_${i + 1}`).css(
            "top",
            $(`#reslimit_body_${i + 1}`).height() / 2 -
              20 +
              $(`#reslimit_body_${i + 1}`).position().top
          );
          setTimes(data, i, increment);
          setTimes(data, i + 1, increment);
        }
      }
    }
  };

  $(`#${targetDiv}`).off("touchend mouseup");
  $(`#${targetDiv}`).on("touchend mouseup", (e) => {
    e.preventDefault();
    data = getSizes(data, c, increment);
  });

  for (let i = 1; i < data.limits.length; ++i) {
    $(`#reslimit_drag_${i}`).off("touchstart mousedown");
    $(`#reslimit_drag_${i}`).on("touchstart mousedown", (e) => {
      e.preventDefault();
      $("#reslimit_block").css("display", "none");
      // data = getSizes(data, c, increment);
      data.limits[i].active = true;
      y = e.pageY;
    });
  }

  $("#reslimit_add_start").off();
  $("#reslimit_add_start").fastClick((e) => {
    e.stopPropagation();
    addStart(targetDiv, data, location, callback);
  });

  $("#reslimit_remove_start").off();
  $("#reslimit_remove_start").fastClick((e) => {
    e.stopPropagation();
    removeStart(targetDiv, data, location, callback);
  });

  $("#reslimit_add_end").off();
  $("#reslimit_add_end").fastClick((e) => {
    e.stopPropagation();
    addEnd(targetDiv, data, location, callback);
  });

  $("#reslimit_remove_end").off();
  $("#reslimit_remove_end").fastClick((e) => {
    e.stopPropagation();
    removeEnd(targetDiv, data, location, callback);
  });

  $("#reslimit_save").off();
  $("#reslimit_save").fastClick((e) => {
    data = getSizes(data, c, increment);
    callback(null, data);
  });

  $(".reslimit_time").off();
  $(".reslimit_time").fastClick((e) => {
    $("#reslimit_block").css("display", "block");
    e.stopPropagation();
    $("#reslimit_block").css(
      "top",
      $(`#${e.target.id}`).parent().position().top -
        $(`#${e.target.id}`).parent().outerHeight() / 2 +
        20
    );
    $("#reslimit_block").css(
      "left",
      $(`#${e.target.id}`).parent().position().left + 155
    );

    // build
    // $('#reslimit_detail').html('<div id="reslimit_respercent"></div>');
    data.limits[$(`#${e.target.id}`).data("index")].seats = data.seats;
    ressplit.create(
      "reslimit_detail",
      data.limits[$(`#${e.target.id}`).data("index")],
      (err, value) => {
        data.limits[$(`#${e.target.id}`).data("index")] = value;
        setTimes(data, $(`#${e.target.id}`).data("index"), increment);
      }
    );
    $("#reslimit_detail").css(
      "top",
      `${0 - $("#reslimit_detail").outerHeight() / 4}px`
    );
  });

  $("#reslimit_detail").off();
  $("#reslimit_detail").fastClick((e) => {
    e.stopPropagation();
  });

  $("#reslimit_shell").off();
  $("#reslimit_shell").fastClick((e) => {
    destroy();
  });

  /*
    $('.accordion_button').off();
    $('.accordion_button').fastClick((e) => {
        e.stopPropagation();
        callback(null, $(`#${e.target.id}`).data('value'));
        TweenMax.to("#component", .2, {alpha:0, scale: 1, ease: Power2.easeIn, onComplete:destroy});
    });
    */
  setTimeout(() => {
    for (let i = 0; i < data.limits.length; ++i) {
      data.limits[i].active = true;
      movethis(0, true);
      data.limits[i].active = false;
    }
  }, 0);
};

const reset = () => {
  create(current.targetDiv, current.data, current.location, current.callback);
};

const setTimes = (data, i, increment) => {
  let adjustment = 0;
  if (i < data.limits.length - 1) {
    let thisTime = moment(
      conf.vars.time[
        Math.floor(
          ($(`#reslimit_drag_${i}`).position().top -
            $("#reslimit_drag_0").position().top +
            adjustment) /
            increment
        ) + data.open
      ],
      "H:mma"
    ).format(time24);
    thisTime += " - ";
    thisTime += moment(
      conf.vars.time[
        Math.floor(
          ($(`#reslimit_drag_${i + 1}`).position().top -
            $("#reslimit_drag_0").position().top +
            adjustment) /
            increment
        ) + data.open
      ],
      "H:mma"
    ).format(time24);
    $(`#reslimit_slide_${i} > .reslimit_time`).html(
      `${thisTime}&nbsp;&nbsp;<i class="fas fa-edit theme_yellow"></i>`
    );
  } else {
    let thisTime = moment(
      conf.vars.time[
        Math.floor(
          ($(`#reslimit_drag_${i}`).position().top -
            $("#reslimit_drag_0").position().top +
            adjustment) /
            increment
        ) + data.open
      ],
      "H:mma"
    ).format(time24);
    thisTime += " - ";
    let lastIndex =
      Math.floor(
        ($(`#reslimit_drag_${i + 1}`).position().top -
          $("#reslimit_drag_0").position().top) /
          increment
      ) + data.open;
    if (lastIndex > 96) {
      lastIndex = 96;
    }
    if (lastIndex > data.close) {
      lastIndex = data.close;
    }
    thisTime += moment(conf.vars.time[data.close], "H:mma").format(time24);
    $(`#reslimit_slide_${i} > .reslimit_time`).html(
      `${thisTime}&nbsp;&nbsp;<i class="fas fa-edit theme_yellow"></i>`
    );
  }

  $(`#reslimit_slide_${i} > .reslimit_preview > .reslimit_preview_box1`)
    .html(`${l.translate("Reservations:")} ${data.limits[i].split}% \
            (${Math.floor(
              (data.limits[i].split / 100) * data.seats
            )} ${l.translate("Seats")})`);
  $(`#reslimit_slide_${i} > .reslimit_preview > .reslimit_preview_box3`)
    .html(`${l.translate("Walk-ins:")} ${100 - data.limits[i].split}% \
            (${Math.floor(((100 - data.limits[i].split) / 100) * data.seats)} \
            ${l.translate("Seats")})`);
  $(`#reslimit_slide_${i} > .reslimit_preview > .reslimit_preview_box2`).html(
    `${l.translate("4-Top Turn Time:")} ${data.limits[i].turnTime}m`
  );
  $(`#reslimit_slide_${i} > .reslimit_preview > .reslimit_preview_box4`).html(
    `${l.translate("Web max party size:")} (${data.limits[i].maxWeb})`
  );
};

const getSizes = (data, c, increment) => {
  for (let i = 0; i < data.limits.length; ++i) {
    data.limits[i].active = false;
    data.limits[i].size = $(`#reslimit_body_${i}`).outerHeight();
    data.limits[i].start =
      Math.floor(
        ($(`#reslimit_drag_${i}`).position().top -
          $("#reslimit_drag_0").position().top) /
          increment
      ) + data.open;
    if (i < data.limits.length - 1) {
      data.limits[i].end =
        Math.floor(
          ($(`#reslimit_drag_${i + 1}`).position().top -
            $("#reslimit_drag_0").position().top) /
            increment
        ) + data.open;
    } else {
      data.limits[i].end = data.close;
    }
  }
  return data;
};

const addStart = (targetDiv, data, location, callback) => {
  if ($("#reslimit_body_0").outerHeight() > 50) {
    data.limits.unshift({
      active: false,
      size: data.limits[0].size / 2 - $("#reslimit_drag_0").outerHeight(),
      split: 50,
      turnTime: 45,
      maxWeb: 12,
    });
    data.limits[1].size = data.limits[1].size / 2;
    create(targetDiv, data, location, callback);
  }
};

const removeStart = (targetDiv, data, location, callback) => {
  if (data.limits.length > 1) {
    data.limits[1].size =
      data.limits[1].size +
      data.limits[0].size +
      $("#reslimit_drag_0").outerHeight();
    data.limits.shift();
    create(targetDiv, data, location, callback);
  }
};

const addEnd = (targetDiv, data, location, callback) => {
  if ($(`#reslimit_body_${data.limits.length - 1}`).outerHeight() > 50) {
    data.limits.push({
      active: false,
      size: data.limits[data.limits.length - 1].size / 2,
      split: 50,
      turnTime: 45,
      maxWeb: 12,
    });
    data.limits[data.limits.length - 2].size =
      data.limits[data.limits.length - 2].size / 2 -
      $(`#reslimit_drag_${data.limits.length - 2}`).outerHeight();
    create(targetDiv, data, location, callback);
  }
};

const removeEnd = (targetDiv, data, location, callback) => {
  if (data.limits.length > 1) {
    data.limits[data.limits.length - 2].size =
      data.limits[data.limits.length - 2].size +
      data.limits[data.limits.length - 1].size +
      $(`#reslimit_drag_${data.limits.length - 2}`).outerHeight();
    data.limits.pop();
    create(targetDiv, data, location, callback);
  }
};

const destroy = () => {
  $("#reslimit_block").css("display", "none");
};

module.exports = {
  create,
  destroy,
  reset,
};



/** WEBPACK FOOTER **
 ** ./src/components/reslimit/index.js
 **/